import React from "react";

import { StructuredTextRenderer } from "../../../components/StructuredTextRenderer";
import { Tagline } from "../../../components/Tagline/Tagline";
import { Headline } from "../../../components/Headline";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./component.module.less";

export function NestedText({
    data: {
        // id,
        text,
        headline,
        tagline,
        semanticOfHeadline,
        noticeHeadline,
        tipHeadline,
        type
    },
    contentElementType,
    hasLightBackground = true
}) {
    return (
        <div className={styles.container}>
            {tagline && (
                <Tagline hasLightBackground={hasLightBackground}>
                    {tagline}
                </Tagline>
            )}

            {headline && (
                <Headline
                    semanticOfHeadline={semanticOfHeadline}
                    hasLightBackground={hasLightBackground}
                >
                    {headline}
                </Headline>
            )}

            {type === "DatoCmsNestedText" ? (
                <StructuredTextRenderer
                    data={text}
                    noContainer
                    contentElementType={contentElementType}
                />
            ) : (
                <div className={styles.textNoticeHintBlock}>
                    {noticeHeadline && (
                        <Headline
                            headlineClass={gcs(
                                styles.textNoticeHintHeadline,
                                styles.noticeIcon
                            )}
                            semanticOfHeadline="H5"
                            hasLightBackground={hasLightBackground}
                        >
                            {noticeHeadline}
                        </Headline>
                    )}
                    {tipHeadline && (
                        <Headline
                            headlineClass={gcs(
                                styles.textNoticeHintHeadline,
                                styles.hintIcon
                            )}
                            semanticOfHeadline="H5"
                            hasLightBackground={hasLightBackground}
                        >
                            {tipHeadline}
                        </Headline>
                    )}

                    <StructuredTextRenderer
                        data={text}
                        noContainer
                        contentElementType={contentElementType}
                    />
                </div>
            )}
        </div>
    );
}
